/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uploading_DialogueInputs */

const en_uploading_dialogue = /** @type {(inputs: Uploading_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading dialogue data...`)
};

const fr_uploading_dialogue = /** @type {(inputs: Uploading_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des données de dialogue...`)
};

const de_uploading_dialogue = /** @type {(inputs: Uploading_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dialogdaten werden hochgeladen...`)
};

const it_uploading_dialogue = /** @type {(inputs: Uploading_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento dei dati del dialogo in corso...`)
};

const ru_uploading_dialogue = /** @type {(inputs: Uploading_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка данных диалога...`)
};

const es_uploading_dialogue = /** @type {(inputs: Uploading_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando datos de diálogo...`)
};

const zh_cn2_uploading_dialogue = /** @type {(inputs: Uploading_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在上传对话数据……`)
};

const ja_uploading_dialogue = /** @type {(inputs: Uploading_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対話データをアップロードしています...`)
};

const hi_uploading_dialogue = /** @type {(inputs: Uploading_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संवाद डेटा अपलोड किया जा रहा है...`)
};

const pt_pt2_uploading_dialogue = /** @type {(inputs: Uploading_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando dados de diálogo...`)
};

/**
* | output |
* | --- |
* | "Uploading dialogue data..." |
*
* @param {Uploading_DialogueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const uploading_dialogue = /** @type {((inputs?: Uploading_DialogueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploading_DialogueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_uploading_dialogue(inputs)
	if (locale === "de") return de_uploading_dialogue(inputs)
	if (locale === "it") return it_uploading_dialogue(inputs)
	if (locale === "ru") return ru_uploading_dialogue(inputs)
	if (locale === "es") return es_uploading_dialogue(inputs)
	if (locale === "zh-CN") return zh_cn2_uploading_dialogue(inputs)
	if (locale === "ja") return ja_uploading_dialogue(inputs)
	if (locale === "hi") return hi_uploading_dialogue(inputs)
	if (locale === "pt-PT") return pt_pt2_uploading_dialogue(inputs)
	return en_uploading_dialogue(inputs)
});